<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderAssignmentEditor } from '../../../model/assignments/header-assignment-editor.hook'

defineOptions({
  name: 'HeaderAssignmentEditor',
})

const {
  refConfig,
} = useHeaderAssignmentEditor()
</script>

<template>
  <div class="box-assignment-editor-header">
    <NavigationBreadcrumbs :config="refConfig" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderAssignmentEditor.scss" />
